import React, { memo } from 'react';
import { IconButton } from '@material-ui/core';
import PropTypes from 'prop-types';
import { ACTION_TYPES } from '../../../../constants';
import EditFilled from '../../../../icons/EditFilled';
import RemoveFilled from '../../../../icons/RemoveFilled';
import { efesBorder } from '../../../../theme';

const ActionIcon = ({ onClick, type, disabled }) => {
  const icons = {
    // TODO: change color constant and sizes
    [ACTION_TYPES.EDIT]: (
      <EditFilled
        color={!disabled ? efesBorder : '#d3d3d3'}
        disabled
      />
    ),
    [ACTION_TYPES.DELETE]: (
      <RemoveFilled
        color={!disabled ? efesBorder : '#d3d3d3'}
        disabled
      />
    ),
  };

  return (
    <IconButton onClick={onClick} disabled={disabled}>
      {icons[type]}
    </IconButton>
  );
};

ActionIcon.propTypes = {
  type: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

ActionIcon.defaultProps = {
  onClick: () => {},
  disabled: false,
};

export default memo(ActionIcon);
